<template>
  <div id="app">
    <div id="top" class="section-anchor" aria-hidden="true"></div>
    <Navbar :rules_url="data.rules_url" />
    <Introduction />
    <Game :embed_url="data.embed_url" :embed_id="embed_id" />
    <Schedule :schedule="data.schedule" />
    <HowToPlay :how_to_play="data.how_to_play" />
    <div class="row sponser-row">
      <div class="col-1-of-1 xx-large:col-1-of-2">
        <!-- needs to be SVG -->
        <SponsorBox
          class="sponser-background"
          logo="@/assets/FanExam_Horiz_3x_Blk_powered.png"
          sponsor_title="The Fan Exam"
        />
      </div>
      <div class="col-1-of-1 xx-large:col-1-of-2">
        <SponsorBox
          showAvatar="true"
          class="bg-color-dark text-on-dark"
          text="WE ARE SO EXCITED TO BRING BACK THE FAN EXAM BACK FOR A SECOND SEASON! JOIN US TWICE A WEEK AS WE GIVE OUT SOME MAJOR PRIZES AND TEST YOUR TRIVIA KNOWLEDGE."
        />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Introduction from "@/components/Introduction";
import Game from "@/components/Game";
import Schedule from "@/components/Schedule";
import HowToPlay from "@/components/HowToPlay";
import SponsorBox from "@/components/SponsorBox";
import Footer from "@/components/Footer";

export default {
  name: "App",
  components: {
    Navbar,
    Introduction,
    Game,
    Schedule,
    HowToPlay,
    SponsorBox,
    Footer,
  },
  data() {
    return {
      data: {
        embed_url: "",
        how_to_play: [],
        prize_quote: {
          name: "",
          text: "",
          title: "",
        },
        rules: "",
        schedule: [],
      },
      embed_id: "0",
    };
  },
  methods: {
    get_data() {
      fetch("https://s3.amazonaws.com/thefanexam.com/data/fanexam_data_2.json")
        .then((response) => response.json())
        .then((data) => {
          this.data = data;
        });
    },
  },
  created() {
    this.get_data();
  },
};
</script>

<style lang="scss">
@import url("~animate.css/animate.min.css");

:root {
  --color-default: #9c9c9c;
  --color-text-on-default: #000;
  --color-primary: #fff;
  --color-text-on-primary: #000;
  --color-secondary: #8dd901;
  --color-text-on-secondary: #000;
  --color-light: #efefef;
  --color-text-on-light: #000;
  --color-dark: #1a1a1a;
  --color-black: #000;
  --color-text-on-dark: #fff;
  --color-link-background: #8dd901;
  --grid-width: 1416px;
}

.animate__animated.animate__jackInTheBox {
  --animate-duration: 1.25s;
}

body {
  font-family: "Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  line-height: 1.25;
  margin-top: 60px;
}

img {
  max-width: 100%;
}

.sponser-row {
  height: 1080px;
}
.sponser-background {
  background-image: url("./assets/bottom_bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
.flex-center {
  align-items: center;
  display: flex;
  justify-content: center;
}

.text-secondary {
  color: var(--color-secondary) !important;
}

.container {
  margin: 0 auto;
  max-width: var(--grid-width);
}

.section-heading {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;

  @media screen and (min-width: 768px) {
    font-size: 3rem;
  }
}

.button {
  background-color: var(--color-link-background);
  border: 1px solid var(--color-text-on-dark);
  border-radius: 9999px;
  color: var(--color-text-on-secondary);
  display: flex;
  font-size: 0.875rem;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0 24px;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 0.25s;

  &.--large {
    min-height: 48px;
  }

  &:hover,
  &:focus {
    background-color: var(--color-light);
  }
}

.reset-icon {
  &::before {
    margin: 0;
  }
}

.icon-size-24 {
  font-size: 24px;
}
.icon-size-36 {
  font-size: 36px;
}

.flex-item-equal {
  flex: 1 0 0px;
  min-width: 1px;
}

.dot-block {
  background: url("assets/dots.png") repeat;
  position: absolute;
}

.section-anchor {
  position: absolute;
  top: -60px;
  left: -99999px;
}

.scrollbar-styled {
  scrollbar-color: var(--color-primary) #c4c4c4;
  scrollbar-width: thin;

  &::-webkit-scrollbar-track {
    background-color: #c4c4c4;
    border-radius: 999px;
  }

  &::-webkit-scrollbar {
    background-color: #c4c4c4;
    border-radius: 999px;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--color-primary);
    border-radius: 999px;
  }
}
</style>
